<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <label :for="'inputField_' + inputData.id" class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </label>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>
        <div class="form__input-container">
            <input class="form__input form__input--number"
                :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                type="number"
                :id="'inputField_' + inputData.id"
                :name="inputData.id"
                :required="inputData.required"
                :class="inputData.error ? 'form__input--error' : ''"
                v-model="inputValue">
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData'],
    emits: ['inputValue'],
    components: {
        'required-indicator': RequiredIndicator
    },
    data() {
        return{
            inputValue: this.inputData.value ? this.inputData.value : '',
        }
    },
    watch: {
        inputValue(){
            this.$emit('inputValue', this.inputData.id, this.inputValue);
        },
        inputData: {
            handler(){
                this.inputValue = this.inputData.value ? this.inputData.value : '';
            },
            deep: true
        }
    }
}
</script>